import { Flame } from "lucide-react";
import Roulette from "./roulette";

export default function MarketplaceFestaJuninaHeader({
    roulettePrizes = [],
}) {

    return (
        <div>
            <div className="absolute top-1 sm:top-3 lg:top-10 xl:top-3 left-0 w-full h-auto overflow-hidden">
                <svg className="w-full h-full" viewBox="0 0 1200 64" fill="none">
                    {/* Bandeirinhas triangulares */}
                    {Array.from({ length: 20 }).map((_, i) => (
                        <g key={i}>
                            <polygon
                                points={`${i * 60},0 ${i * 60 + 30},32 ${i * 60 + 60},0`}
                                fill={i % 4 === 0 ? "#dc2626" : i % 4 === 1 ? "#ea580c" : i % 4 === 2 ? "#ca8a04" : "#16a34a"}
                                opacity="0.8"
                            />
                        </g>
                    ))}
                </svg>
            </div>

            <div className="w-full mx-auto mb-12 text-center mt-8">
                <div className="flex items-center justify-center gap-4 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center">
                        <Flame className="w-8 h-8 text-white" />
                    </div>
                    <h1 className="text-5xl font-bold bg-gradient-to-r from-orange-600 via-red-600 to-amber-600 bg-clip-text text-transparent">
                        Arraiá da Facilita
                    </h1>
                    <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center">
                        <Flame className="w-8 h-8 text-white" />
                    </div>
                </div>
                <p className="text-2xl text-gray-700 mb-3 font-bold">Advogado Arretado com Sorte!</p>
                <p className="text-xl text-gray-600 mb-8 max-w-4xl mx-auto">
                    Venha pro arraiá mais animado do mundo jurídico! Automatize seu escritório e ainda concorra a prêmios
                    incríveis na nossa roleta da sorte!
                </p>

                {/* Banner da roleta */}
                <Roulette
                    prizes={roulettePrizes}
                    subtitle={(
                        <span>
                            Compre um pacote <span className="font-bold bg-white/20 px-2 py-1 rounded">Premium</span> ou{" "}
                            <span className="font-bold bg-white/20 px-2 py-1 rounded">Infinity</span> e gire nossa roleta da sorte!
                        </span>
                    )}
                    footer="Todos ganham! Ninguém sai de mãos vazias!"
                    showList={false}
                    allowSpin={false}
                />
            </div>
        </div>
    )
}

